// ============================================================
// SIGMA SMART™ · 120+ DONE-FOR-YOU TEMPLATES FOR THERAPISTS™
// All editable values for this landing live in this file.
// ============================================================

// Real Impultienda checkout. ONLY the button inside the offer section goes here.
// utm_* and fbclid from the landing URL are forwarded automatically (lib/checkout.ts).
export const CHECKOUT_URL = 'https://120-done-for-you-templates-therapists.impultienda.ar/checkout';

// Meta Pixel ID (numbers only). Empty = pixel does nothing.
export const META_PIXEL_ID = '';

// Horizontal bundle WITHOUT background (main product + 4 bonuses), WEBP from Photopea (20%).
// Used in the hero, in the offer AND again in the footer, right before the support email.
// Empty = a coded mockup is shown instead.
export const HERO_BUNDLE_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab005b35-25f9-4738-aa80-b7d822339e29/1793763406027_tt-11-bundle-sinfondo-7d3f70fc.webp';

// One WEBP cover per bonus, in order (1 to 4). Empty string = coded cover fallback.
export const BONUS_IMAGES: string[] = [
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab005b35-25f9-4738-aa80-b7d822339e29/1793763411691_tt-03-bono1-84a38837.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab005b35-25f9-4738-aa80-b7d822339e29/1793763416959_tt-04-bono2-b270161b.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab005b35-25f9-4738-aa80-b7d822339e29/1793763422784_tt-05-bono3-0f8e1723.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ab005b35-25f9-4738-aa80-b7d822339e29/1793763428303_tt-06-bono4-89ed2c3c.webp',
];

export const PRICE = 27;
export const ORIGINAL_PRICE = 54;
export const CURRENCY = 'USD';

export const SEO = {
  title: '120+ Done-For-You Templates for Therapists™ | SIGMA SMART™',
  description:
    '126 editable Word + PDF templates for therapists and counselors in private practice: intake, consent, SOAP/DAP/BIRP notes, treatment plans, billing and client letters. Instant download + 4 bonuses.',
};

export const SUPPORT_EMAIL = 'soporte.sigmasmart@gmail.com';
export const INSTAGRAM_HANDLE = '@sigmasmart.en';
export const INSTAGRAM_URL = 'https://instagram.com/sigmasmart.en';
